export const env = {
  mapboxToken: (import.meta.env.VITE_MAPBOX_TOKEN as string | undefined) ?? '',
  /** Deterministic replay GPS for E2E. Only compiled into dedicated test builds. */
  testGpsEnabled: import.meta.env.VITE_ENABLE_TEST_GPS === 'true',
  defaultRegionId: 'DA_NANG',
};
